import { FormBase } from 'core/components';

export default class FacilityOrderTemplateInvoiceNoteModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'secondaryInsuranceVerified',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.INVOICE_NOTE',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.INVOICE_NOTE_PLACEHOLDER',
                    rules: 'string'            
                },
            ],
        };
    }
}
